"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClaimValues = getClaimValues;
exports.hasSystemPermission = hasSystemPermission;
const claim_validator_1 = require("./claim-validator");
const constants_1 = require("./constants");
function getClaimValues(applicationClaims, claimKey, context = constants_1.contexts.genesys) {
    const claim = applicationClaims[context] &&
        applicationClaims[context][claimKey.toLowerCase()];
    if (!claim) {
        return undefined;
    }
    return claim;
}
function hasSystemPermission(applicationClaims, systemTypeId) {
    // Developer has all permissions
    //   console.log(`HasSystemPermission: ${systemTypeId}`);
    if ((0, claim_validator_1.checkPermission)(applicationClaims, constants_1.genesysUserClaims.developer)) {
        // console.log(`HasSystemPermission: developer`);
        return true;
    }
    if ((0, claim_validator_1.hasPermission)(applicationClaims, constants_1.systemTypeClaims.create, systemTypeId)) {
        // console.log(`HasSystemPermission: create ${systemTypeId}`);
        return true;
    }
    //   console.log(`HasSystemPermission: no permission`);
    return false;
}
//# sourceMappingURL=utils.js.map